import { getSecondsSinceAppMount, getSecondsSinceSessionStart } from '../../utils/appMount';
import { firebaseAuth } from '../firebase';
import { platformContextService } from '../platformContext/PlatformContextService';
import { PlatformEnum } from '../platformContext/platformContextTypes';

function getDevice() {
  const { platform } = platformContextService.getConfig();
  if (platform === PlatformEnum.APP_ANDROID || platform === PlatformEnum.APP_IOS) {
    return 'Mobile';
  }
  if (navigator.maxTouchPoints > 0) {
    return 'Web Mobile';
  }
  return 'Web Desktop';
}

function getScreenSize() {
  return `${window?.screen.availWidth}x${window?.screen.availHeight}`;
}

/*
 https://docs.google.com/spreadsheets/d/1mGVr8ApD_0UEYPsmIOgQ5Qelr51fmjVeM6EBViX-A6w/edit#gid=131408382
 Required params
 ✔️"device",
 ✔️"user_id",
 ✔️"screen_size",
 Autogenerated params
 ✔️"referrer",
 */

export function commonAnalyticsEventProps() {
  return {
    referrer: document.referrer,
    device: getDevice(),
    platform: platformContextService.getConfig().platform,
    screen_size: getScreenSize(),
    user_id: firebaseAuth.currentUser?.uid,
    session_time_secs: getSecondsSinceSessionStart(),
    since_app_mount_secs: getSecondsSinceAppMount(),
  };
}
